/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxInputComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CheckboxInputComponent implements ControlValueAccessor {
  @Input() childForm: FormGroup;

  @Input() formControlName: string;

  @Input() id?: string;

  @Input() label: string;

  @Input() innerHtmlLabel: string;

  @Input() required? = false;

  @Input() formControlError?: string;

  @Output() valueChange? = new EventEmitter<boolean>();

  onCheckboxChange(event: Event): void {
    const value = (event.target as HTMLInputElement).checked;
    this.valueChange.emit(value);
  }

  getFormControl(): FormControl {
    return this.childForm.get(this.formControlName) as FormControl;
  }

  onChange: any = () => {};

  onTouched: any = () => {};

  writeValue(value: any): void {
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
